/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'add': {
    viewBox: '0 0 32 32',
    data: '<path d="M28,15H17V4c0-0.6-0.4-1-1-1s-1,0.4-1,1v11H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h11v11c0,0.6,0.4,1,1,1s1-0.4,1-1V17h11 c0.6,0,1-0.4,1-1S28.6,15,28,15z"/>'
  }
})
